import { Tooltip } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { cropRow } from '../../../../shared/lib/helpers/crop-row'

interface CountriesCellProps {
  id: number
  countries: string[]
  is_demo: boolean
}

export const CountriesCell = ({ id, countries, is_demo }: CountriesCellProps) => {
  const navigate = useNavigate()
  const { visible, hidden } = cropRow(countries, 25)

  return (
    <div className={'flex w-fit items-center gap-[8px]'}>
      <span
        className={`truncate border-b border-dotted text-focus ${is_demo ? 'cursor-default' : 'cursor-pointer'} `}
        onClick={() => !is_demo && navigate(`/projects/${id}/locations`)}
      >
        {visible}
      </span>
      {!!hidden.length && (
        <Tooltip title={hidden.join(', ')}>
          <span
            className={
              'ml-auto cursor-default rounded-[4px] bg-focus-50 p-[4px] text-[13px] leading-[13px] text-aqua-300'
            }
          >
            +{hidden.length}
          </span>
        </Tooltip>
      )}
    </div>
  )
}
